import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonList = () => {
    return (
         <section className="w-full">
        <ul className="list flex">
          {Array(4)
            .fill()
            .map((item, index) => (
              <li className="card w-full px-4" key={index}>
               <h2 className="section-title status-title py-4">
              <Skeleton duration={2} height={30} width={`100%`} />
                </h2>
                <Skeleton height={`100vh`} />
              </li>
            ))}
        </ul>
     </section>
    );
  };

  export default SkeletonList;